import classNames from 'classnames';
import type { LocaleResources } from 'locales';
import React from 'react';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { ModalIcon, iconType } from 'src/components/shared/elements/modals/ModalIcon';
import { toJSX } from 'src/utils/toJSXHelper';
import styles from './index.module.scss';

type Props = {
  localeResources: LocaleResources;
  handleClose: () => void;
  handleButtonClick: (() => void) | undefined;
  titleWithDate: string;
  shouldNotifyArrival?: boolean;
};

export const Presenter: React.FC<Props> = ({
  localeResources,
  handleClose,
  handleButtonClick,
  titleWithDate,
  shouldNotifyArrival
}) => {
  return (
    <CommonModal
      closeModal={handleClose}
      fixedElement={
        <>
          <ModalIcon type={iconType.ALERT} />
          <div className={styles.title}>{toJSX(titleWithDate)}</div>
          <div className={styles.description}>{localeResources.products.notice.restockNotificationEmail}</div>
          <div className={styles.description}>{localeResources.products.notice.restockNotificationEmailNote}</div>
          <button
            className={classNames(styles.button, { [styles.disabled]: shouldNotifyArrival })}
            onClick={handleButtonClick}
            disabled={shouldNotifyArrival}
          >
            <label>
              {shouldNotifyArrival
                ? localeResources.products.notice.restockNotificationSet
                : localeResources.products.notice.wishRestockNotification}
            </label>
          </button>
        </>
      }
    />
  );
};
